import axios from "axios"
import checkResponse from "../helpers/responseService"

export default {

  getRates() {
    return axios.get('/rates')
      .then(response => checkResponse(response))
  },
  saveRates(rates) {
    return axios.post('/rates', rates)
      .then(response => checkResponse(response))
  }
}



// WEBPACK FOOTER //
// ./resources/js/services/ratesDataService.js